export const GET_RESERVATIONS = 'GET_RESERVATIONS';
export const GET_RESERVATIONS_SUCCEEDED = 'GET_RESERVATIONS_SUCCEEDED';
export const GET_RESERVATIONS_FAILED = 'GET_RESERVATIONS_FAILED';

export const GET_PAST_RESERVATIONS = 'GET_PAST_RESERVATIONS';
export const GET_PAST_RESERVATIONS_SUCCEEDED = 'GET_PAST_RESERVATIONS_SUCCEEDED';
export const GET_PAST_RESERVATIONS_FAILED = 'GET_PAST_RESERVATIONS_FAILED';

export const GET_RESERVATION_DETAILS = 'GET_RESERVATION_DETAILS';
export const GET_RESERVATION_DETAILS_SUCCEEDED = 'GET_RESERVATION_DETAILS_SUCCEEDED';
export const GET_RESERVATION_DETAILS_FAILED = 'GET_RESERVATION_DETAILS_FAILED';

export const CANCEL_BOOKING = 'CANCEL_BOOKING';
export const CANCEL_BOOKING_SUCCEEDED = 'CANCEL_BOOKING_SUCCEEDED';